module.exports = __webpack_public_path__ + "static/img/n-task.a8092624.png";